jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 1,
  scroll: 1,
});

// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

// 顶部时间轮播
new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: true,
});
new Swiper(".sp-swiper2", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
});

let prods = window.product
function getCur(){
  let color = $('#opt1 div.active').attr('data-val')
  let amount = $('#opt2 div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == amount)[0]
}
function changePrice(){
  let num = $('.addGroup input').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('.product-part .price-group .price1 span').html(price)
  $('.product-part .price-group .price2 span').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .off_box span").html(off_font);
}

$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
  changePrice()
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice()
});

// let spImgList1 = [
//   "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240526-b1.jpg",
//   "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240526-b2.jpg",
//   "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240526-b3.png",
// ];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    // preloadImages(spImgList1);
    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") +
            -255 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let spImgList = [
  "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240605-p1.jpg",
  "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240605-p2.png",
  "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240605-p3.png",
  "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240605-p4.jpg",
  "https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240605-p5.jpg",
];
$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项
  let colorOptions = $("#sp-color .option.active").index();
  if (colorOptions == 0) {
    swiper.slideTo(2);
  } else if (colorOptions == 1) {
    swiper.slideTo(1);
  }

  let index1 = $('#opt1 div.active').index()
  let index2 = $('#opt2 div.active').index()
  if(index2 == 0){
    $('.p-img-wrap .select1').show()
    $('.p-img-wrap .select2').hide()
    $('.p-img-wrap .font_box').hide()
  }else{
    $('.p-img-wrap .select1').hide()
    $('.p-img-wrap .select2').show()
    $('.p-img-wrap .font_box').show()
  }
  if(index1 == 0 && index2 == 0){
    $('.p-img-wrap .select1').attr('src', 'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/pocket1.png')
  }else if(index1 == 1 && index2 == 0){
    $('.p-img-wrap .select1').attr('src', 'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/pocket3.png')
  }
  if(index1 == 0 && index2 > 0){
    $('.p-img-wrap .select2').attr('src', 'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/pocket2.png')
  }else if(index1 == 1 && index2 > 0){
    $('.p-img-wrap .select2').attr('src', 'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/pocket4.png')
  }
  changePrice()
});

$('.buyNow').click(function(){
  let num = $('.addGroup input').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})


$('.cart_btn').click(function(){
  $('.c_toast').show()
  setTimeout(function () {
    $('.c_toast').hide()
  }, 1200);
  
  var data = {
    id: getCur().id,
    quantity: $('.addGroup input').val(),
  };
  
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $(".buy-car span").html(result.item_count);
      });
    },
    dataType: "json",
  });
  
  let index = $('#opt2 div.active').index()
  var img = $(".p-img-wrap .select1");
  if(index == 0){
    img = $(".p-img-wrap .select1");
  }else{
    img = $(".p-img-wrap .select2");
  }
  var flyer = img[0].cloneNode(true);
  flyer.classList.add("sp-clone");
  
  $("#shopping").append(flyer);
  $(".sp-clone").css({
    width: img[0].width,
    height: img[0].height,
    position: "fixed",
    top: img[0].offsetTop + $(".sp-nav-top").height(),
    left: img.offset().left,
    "z-index": "99",
  });
  
  let finish = $(".buy-car");
  $(".sp-clone").animate(
    {
      top: finish[0].offsetTop + $('.time-part').height(),
      left: finish[0].offsetLeft + finish.width() / 2,
      width: 50, // 结束时的大小，根据需要调整
      height: 50, // 结束时的大小，根据需要调整
      opacity: 0.4,
    },
    500,
    "linear",
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0,
      );
    }
  );
})